export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  listOptions(state) {
    return state.listOptions;
  },
  stringFilter(state) {
    const filters = [];
    if (state.searchText) {
      filters.push(`transportadora like "%${state.searchText.toLowerCase()}%" or identificador like "%${state.searchText.toLowerCase()}%"`);
    }
    if (state.selectedStatus && state.selectedStatus.value) {
      filters.push(`situacao in ('${state.selectedStatus.value.join('\',\'')}')`);
    }

    if (!filters.length) {
      return '';
    }

    return filters.join(' and ');
  },
};
